/**
 * История поиска — orchestrator модуля
 * Delegates dropdown management to dropdown.js, keyboard nav to keyboard.js.
 * Binds DOM events and exports the public SEARCH_HISTORY API.
 * # ⛓️ CURSOR_ANCHOR:search:history-orchestrator
 */
(function() {
  var ds = window._historyDropdown;
  if (!ds) {
    console.error('[HISTORY] dropdown.js must be loaded before history.js');
    return;
  }
  var state = ds.state;

  function initSearchHistory() {
    console.log('[HISTORY] Initializing search history...');

    // Restore CURRENT_HISTORY_ID from URL (?hid=...) on page load
    if (window.restoreActiveHistoryFromUrl) {
      var restored = window.restoreActiveHistoryFromUrl();
      if (restored) {
        console.log('[HISTORY] Restored active chain from URL: hid=' + restored);
      }
    }

    // Initialize tabs and settings
    if (typeof initModalTabs === 'function') {
      initModalTabs();
    } else if (window.initModalTabs) {
      window.initModalTabs();
    }

    if (typeof applyLanguageSettings === 'function') {
      applyLanguageSettings();
    } else if (window.applyLanguageSettings) {
      window.applyLanguageSettings();
    }

    // Check if history saving is disabled
    var historyDisabled = false;
    if (typeof isHistoryDisabled === 'function') {
      historyDisabled = isHistoryDisabled();
    } else if (window.isHistoryDisabled) {
      historyDisabled = window.isHistoryDisabled();
    }
    console.log('[HISTORY] History disabled:', historyDisabled);

    var historyButton = document.getElementById('search-history-button');
    var disableCheckbox = document.getElementById('search-history-disable-checkbox');
    console.log('[HISTORY] History button found:', !!historyButton);
    console.log('[HISTORY] Disable checkbox found:', !!disableCheckbox);

    if (historyButton) {
      historyButton.style.display = '';

      var dropdown = document.getElementById('search-history-dropdown');
      var searchInput = document.getElementById('search');

      // Initialize shared dropdown state with DOM refs
      ds.initDropdownState(dropdown, searchInput, historyButton);

      // Set up touch handlers for mobile scroll prevention
      ds.setupTouchHandlers();

      // Set up keyboard navigation (input filter + keydown)
      if (searchInput) {
        disableBrowserAutocomplete(searchInput);

        if (window._historyKeyboard) {
          window._historyKeyboard.setupKeyboardNavigation(searchInput);
        }
      }

      // Toggle dropdown on history button click
      historyButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (dropdown) {
          if (!dropdown.classList.contains('active')) {
            ds.openHistoryDropdown();
          } else {
            ds.closeHistoryDropdown();
          }
        }
      });

      // Close dropdown on search button click
      var searchButton = document.querySelector('.search-button');
      if (searchButton) {
        searchButton.addEventListener('click', function() {
          ds.closeHistoryDropdown();
        });
      }

      // Show full history on focus when search input is empty
      if (searchInput) {
        searchInput.addEventListener('focus', function() {
          if (!this.value.trim() && dropdown && !dropdown.classList.contains('active')) {
            ds.resetHistorySelection();
            if (typeof renderHistory === 'function') {
              renderHistory();
            }
            var history = (typeof getHistory === 'function') ? getHistory() : [];
            if (history && history.length > 0) {
              dropdown.classList.add('active');
              if (historyButton) {
                historyButton.classList.add('is-open');
                historyButton.setAttribute('aria-expanded', 'true');
              }
              ds.restoreLastSelection();
              ds.lockMobileScroll();
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  ds.updateDropdownHeight();
                });
              });
            }
          }
        });
      }

      // Close on outside click
      document.addEventListener('click', function(e) {
        setTimeout(function() {
          if (dropdown && dropdown.classList.contains('active')) {
            var isSearchInput = e.target === searchInput || e.target.id === 'search';
            var isSearchInputGroup = e.target.closest && e.target.closest('.search-input-group');
            var isHistoryBtn = e.target === historyButton || (historyButton && historyButton.contains(e.target));

            if (!dropdown.contains(e.target) && !isHistoryBtn && !isSearchInput && !isSearchInputGroup) {
              ds.closeHistoryDropdown();
            }
          }
        }, 10);
      });
    }

    // Dropdown clear button handler — кастомная модалка подтверждения.
    var dropdownClearBtn = document.getElementById('search-history-dropdown-clear');
    if (dropdownClearBtn) {
      dropdownClearBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        openClearHistoryConfirm();
      });
    }

    // Disable history checkbox
    if (disableCheckbox) {
      disableCheckbox.checked = historyDisabled;
      disableCheckbox.addEventListener('change', function() {
        if (typeof setHistoryDisabled === 'function') {
          setHistoryDisabled(this.checked);
        } else if (window.setHistoryDisabled) {
          window.setHistoryDisabled(this.checked);
        }
        if (typeof renderHistory === 'function') {
          renderHistory();
        } else if (window.renderHistory) {
          window.renderHistory();
        }
      });
    }

    // Legacy clear button handler — та же модалка.
    var clearBtn = document.getElementById('search-history-clear-btn');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        openClearHistoryConfirm();
      });
    }

    // Confirm modal wiring — один раз.
    _bindClearHistoryConfirm();

    // Initial render
    if (typeof renderHistory === 'function') {
      renderHistory();
    } else if (window.renderHistory) {
      window.renderHistory();
    }
  }

  // --- Helpers ---

  /** Disable browser autocomplete on search input with cross-browser hacks. */
  function disableBrowserAutocomplete(searchInput) {
    searchInput.setAttribute('autocomplete', 'off');
    searchInput.setAttribute('autocapitalize', 'off');
    searchInput.setAttribute('spellcheck', 'false');

    // Some browsers ignore "off"; cycle through "new-password" as workaround
    setTimeout(function() {
      if (searchInput) {
        searchInput.setAttribute('autocomplete', 'new-password');
        setTimeout(function() {
          if (searchInput) searchInput.setAttribute('autocomplete', 'off');
        }, 100);
      }
    }, 0);
  }

  // Сколько самых свежих цепочек оставляет кнопка «Оставить последние N цепочек».
  // Число зашито и в переводы (history_keep_last_chains) — менять синхронно.
  var KEEP_LAST_CHAINS = 30;

  /** Opens the custom confirm-clear-history modal. */
  function openClearHistoryConfirm() {
    var modal = document.getElementById('confirm-clear-history-modal');
    if (!modal) return;

    // Контекстная подсказка: привязан Telegram → очистка затронет все устройства.
    var linked = !!(window.TG_ACCOUNT && window.TG_ACCOUNT.linked);
    var noteLocal = document.getElementById('confirm-clear-history-note-local');
    var noteSynced = document.getElementById('confirm-clear-history-note-synced');
    if (noteLocal) noteLocal.classList.toggle('confirm-modal-hidden', linked);
    if (noteSynced) noteSynced.classList.toggle('confirm-modal-hidden', !linked);

    // «Оставить последние 30 цепочек» имеет смысл только когда цепочек больше 30.
    var keepBtn = document.getElementById('confirm-clear-history-keep');
    var altWrap = keepBtn ? keepBtn.parentElement : null;
    if (altWrap) {
      var countFn = typeof countHistoryChains === 'function' ? countHistoryChains : window.countHistoryChains;
      var chains = countFn ? countFn() : 0;
      altWrap.classList.toggle('confirm-modal-hidden', chains <= KEEP_LAST_CHAINS);
    }

    modal.classList.add('active');
    // autofocus на Cancel — безопасный дефолт (Esc тоже закрывает).
    var cancelBtn = document.getElementById('confirm-clear-history-cancel');
    if (cancelBtn) setTimeout(function() { cancelBtn.focus(); }, 0);
  }

  /** Closes the confirm-clear-history modal. */
  function closeClearHistoryConfirm() {
    var modal = document.getElementById('confirm-clear-history-modal');
    if (modal) modal.classList.remove('active');
  }

  /** Binds OK/Cancel/Esc once for the confirm-clear modal. */
  function _bindClearHistoryConfirm() {
    var modal = document.getElementById('confirm-clear-history-modal');
    if (!modal || modal._bound) return;
    modal._bound = true;

    var okBtn = document.getElementById('confirm-clear-history-ok');
    var cancelBtn = document.getElementById('confirm-clear-history-cancel');

    if (okBtn) {
      okBtn.addEventListener('click', function() {
        if (typeof clearHistory === 'function') clearHistory();
        else if (window.clearHistory) window.clearHistory();
        if (typeof renderHistory === 'function') renderHistory();
        else if (window.renderHistory) window.renderHistory();
        closeClearHistoryConfirm();
      });
    }
    if (cancelBtn) {
      cancelBtn.addEventListener('click', closeClearHistoryConfirm);
    }

    var keepBtn = document.getElementById('confirm-clear-history-keep');
    if (keepBtn) {
      keepBtn.addEventListener('click', function() {
        var trimFn = typeof trimHistoryChains === 'function' ? trimHistoryChains : window.trimHistoryChains;
        if (trimFn) trimFn(KEEP_LAST_CHAINS);
        if (typeof renderHistory === 'function') renderHistory();
        else if (window.renderHistory) window.renderHistory();
        closeClearHistoryConfirm();
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeClearHistoryConfirm();
      }
    });
  }

  // Экспорт для inline-обработчиков overlay/close кнопки в HTML.
  window.openClearHistoryConfirm = openClearHistoryConfirm;
  window.closeClearHistoryConfirm = closeClearHistoryConfirm;

  /** Get localized confirmation text for clearing history. */
  function getConfirmClearText() {
    var text = 'Are you sure you want to clear search history?';
    if (typeof LANG_TEXTS !== 'undefined' && window.SEARCH_LANGUAGE) {
      var currentLang = window.SEARCH_LANGUAGE.getCurrentLang();
      if (LANG_TEXTS[currentLang] && LANG_TEXTS[currentLang].history_clear_confirm) {
        text = LANG_TEXTS[currentLang].history_clear_confirm;
      }
    }
    return text;
  }

  // --- Public API export ---

  window.SEARCH_HISTORY = {
    addToHistory: typeof addToHistory !== 'undefined' ? addToHistory : window.addToHistory,
    updateActiveHistoryDisplay: window.updateActiveHistoryDisplay || null,
    lockHistoryItem: window.lockHistoryItem || null,
    getHistoryById: window.getHistoryById || null,
    getHistoryChildren: window.getHistoryChildren || null,
    getHistoryRootChain: window.getHistoryRootChain || null,
    getHistory: typeof getHistory !== 'undefined' ? getHistory : window.getHistory,
    clearHistory: typeof clearHistory !== 'undefined' ? clearHistory : window.clearHistory,
    renderHistory: typeof renderHistory !== 'undefined' ? renderHistory : window.renderHistory,
    filterHistoryItems: typeof filterHistoryItems !== 'undefined' ? filterHistoryItems : window.filterHistoryItems,
    initSearchHistory: initSearchHistory,
    saveSearchToHistory: typeof saveSearchToHistory !== 'undefined' ? saveSearchToHistory : window.saveSearchToHistory,
    isHistoryDisabled: typeof isHistoryDisabled !== 'undefined' ? isHistoryDisabled : window.isHistoryDisabled,
    setHistoryDisabled: typeof setHistoryDisabled !== 'undefined' ? setHistoryDisabled : window.setHistoryDisabled,
    getHiddenLangs: typeof getHiddenLangs !== 'undefined' ? getHiddenLangs : window.getHiddenLangs,
    getHiddenDicts: typeof getHiddenDicts !== 'undefined' ? getHiddenDicts : window.getHiddenDicts,
    updateDropdownHeight: ds.updateDropdownHeight,
    closeHistoryDropdown: ds.closeHistoryDropdown,
    setLastSelectedTerm: function(term, index, historyId) {
      state.lastSelectedTerm = term;
      if (index !== undefined) state.lastSelectedIndex = index;
      if (historyId) state.lastSelectedHistoryId = historyId;
    }
  };

  console.log('[HISTORY] Module loaded, window.SEARCH_HISTORY exported:', !!window.SEARCH_HISTORY);
  console.log('[HISTORY] initSearchHistory available:', !!(window.SEARCH_HISTORY && window.SEARCH_HISTORY.initSearchHistory));
})();
